export function setMermaidSvg(wrapper: HTMLElement, canvas: HTMLElement, svg: string): void {
  canvas.innerHTML = svg;
  const viewBox = canvas.querySelector("svg")?.getAttribute("viewBox")
    ?.trim().split(/[\s,]+/).map(Number);
  const naturalWidth = viewBox?.[2];
  if (!naturalWidth || !Number.isFinite(naturalWidth)) return;
  const chromeWidth = Math.max(0,
    wrapper.getBoundingClientRect().width - canvas.getBoundingClientRect().width);
  wrapper.style.setProperty("--md-mermaid-natural-width",
    `${Math.ceil(naturalWidth + chromeWidth)}px`);
}
